export enum NuggetMode {
  Default = 'default',
  NotificationSetting = 'notification-setting'
}
